import {
  SET_MCQ_QUESTIONS,
  SET_MCQ_LOADING,
  SET_LESEN_PASSAGE,
  SET_AUDIO_QUESTIONS,
} from "../Actions/types";

const initialState = {
  mcqQuestions: [],
  audioQuestions: [],
  totalPages: 0,
  currentPage: 0,
  loading: false,
  lesenPassage: null,
};

const einstufungReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MCQ_LOADING:
      return { ...state, loading: true };

    case SET_MCQ_QUESTIONS:
      return {
        ...state,
        mcqQuestions: action.payload.content,
        totalPages: action.payload.totalPages,
        currentPage: action.payload.number,
        loading: false,
      };

    case SET_AUDIO_QUESTIONS:
      return {
        ...state,
        audioQuestions: action.payload.content,
        totalPages: action.payload.totalPages,
        currentPage: action.payload.number,
        loading: false,
      };

    case SET_LESEN_PASSAGE:
      return {
        ...state,
        lesenPassage: action.payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default einstufungReducer;
